let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9igas")).then(() => parcelRequire('21oBo'));